module.exports = __webpack_public_path__ + "img/no_data.bd98cff0.png";